import posthog from 'posthog-js';

export const POSTHOG_SESSION_HEADER = 'X-POSTHOG-SESSION-ID';

// Only use for Assembly API requests; storage uploads and third-party APIs
// must not receive our browser session identifier.
export const withPosthogSession = <T extends Record<string, unknown>>(
  headers: T,
) => {
  try {
    if (
      typeof window === 'undefined' ||
      !posthog.__loaded ||
      posthog.has_opted_out_capturing()
    ) {
      return headers;
    }
    // Read per request because inactivity and logout can rotate the session.
    const sessionId = posthog.get_session_id();
    return sessionId
      ? { ...headers, [POSTHOG_SESSION_HEADER]: sessionId }
      : headers;
  } catch {
    return headers;
  }
};
